import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';

@Directive({
  selector: '[gmtAuth]'
})
export class AuthDirective implements OnInit {
  @Input('gmtAuth') gmtAuth: string;

  constructor(
      private elementRef: ElementRef,
      private authService: AuthService
  ) {}

  ngOnInit() {
    if (this.gmtAuth && !this.authService.hasPermission(this.gmtAuth)) {
      this.elementRef.nativeElement.style.display = 'none';
    }
  }
}
